import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";

const ModalDetailsRole = ({ open, setOpen, roleData, type }) => {
  // console.log("roleData", roleData);

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle variant="h6" fontWeight="bold">
        Información del rol {roleData?.name ?? ""}
      </DialogTitle>
      <DialogContent>
        <Grid
          container
          spacing={4}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <Grid item xs={12} sm={6} md={6}>
            <Box margin={2}>
              <Typography fontWeight="bold"> Nombre:</Typography>
              <Typography>{roleData?.name ?? "Sin dato"}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Box margin={2}>
              <Typography fontWeight="bold"> Descripción:</Typography>
              <Typography>{roleData?.description ?? "---"}</Typography>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
          onClick={() => {
            setOpen(false);
          }}
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ModalDetailsRole;
